import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Content } from './components/content';
import { playerInterfaceWrapper } from './player-interface';
import { Text } from '../components/text';
import styled from 'styled-components';
import { Colors } from '../constants';
import { useSolution } from './hooks';
import { Loader } from 'semantic-ui-react';

const OptionWrapper = styled.div<any>`
  display: flex;
  gap: 16px;
  padding: 16px;
  border: 2px solid ${Colors.BROWN};
  width: 100%;
`;

export const PresentSelected = playerInterfaceWrapper(({ data, getImg }) => {
  const { t } = useTranslation();
  const { scoring, currentStep } = data;
  const { answers } = currentStep;

  const { selectedOption, loading } = useSolution(scoring);

  const Option = ({ answer, option }: { answer: any; option: any }) => {
    console.log(option.text);
    return option ? (
      <OptionWrapper>
        <img alt={`option-${answer}`} height={70} src={getImg(answer)} />
        {/*todo dangerouslySetInnerHTML do not work here - wtf*/}
        {/*<Text dangerouslySetInnerHTML={{ __html: option.text }} />*/}
        <Text>{option.text}</Text>
      </OptionWrapper>
    ) : null;
  };

  if (loading) return <Loader inverted active />;

  if (!selectedOption)
    return (
      <Content>
        <Text alignCenter>{t('chronos.noAnswer')}</Text>
      </Content>
    );

  return (
    <Content>
      <Text marginTop={16} marginBottom={16} alignCenter>
        {t('chronos.selectedAnswer')}
      </Text>
      <Option answer={selectedOption} option={answers[selectedOption]} />
    </Content>
  );
});
